import Loading from '../misc/Loading';
import React from 'react';
import OpenGraphModel from '../../../../model/openGraph';
import {NavLink as Link} from 'react-router-dom';
import withRouter from '/src/components/misc/withRouter';
import PublishStatusTableRow from '../table/PublishStatusTableRow';
import PublishStatusDot from '../../../misc/PublishStatusDot';

class OpenGraphList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modified: false,
      working: true,
      error: null,
      hideArchived: true,
      leases: []
    };
  }

  componentDidMount() {
    document.title = 'Admin - Opengraph';

    return Promise.all([
      OpenGraphModel.getAll(1)
    ]).then(([leases]) => {
      this.setState({
        leases: leases,
        working: false
      });
    });
  }

  toggleShowArchived() {
    this.setState({
      hideArchived: !this.state.hideArchived
    });
  }

  printButtonGroup() {
    return (
      <div className="pull-right">
        {this.state.working &&
          <span><i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...&nbsp;</span>
        }
        <button onClick={() => {
          this.toggleShowArchived();
        }} className="btn btn-info" disabled={this.state.working}>
          {this.state.hideArchived ? 'Vis arkiverte' : 'Skjul arkiverte'}
        </button>
        &nbsp;
        &nbsp;
        <Link
          to={'/lease/new'}
          className="btn btn-success"
          disabled={this.state.working}
        >
          Ny lease
        </Link>
      </div>
    );
  }

  render() {
    if (this.state.working) {
      return <Loading title="Opengraph" text="Laster" />;
    }

    this.selectedMake = this.state.filter && this.state.makes.find((make) => make.id === this.state.filter);

    return (
      <section>
        <div className="mf-model">
          <ol className="breadcrumb mf-margin-top-20">
            <li><Link to="/">Forsiden</Link></li>
            <li className="active">Opengraph</li>
          </ol>
          <div className="page-header">
            {this.printButtonGroup()}
            <h1>Opengraph</h1>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th title="Publiseringsstatus"></th>
                  <th>Navn</th>
                  <th>Url</th>
                  <th>Mode</th>
                  <th>Merke</th>
                </tr>
              </thead>

              <tbody>
                {this.state.leases.map((lease) => {
                  if (this.state.hideArchived && lease.archived) {
                    return;
                  }

                  return (
                    <PublishStatusTableRow entry={lease} key={`lease-${lease.id}`}>
                      <td className="text-center">
                        <PublishStatusDot entry={lease} />
                      </td>
                      <td><Link to={`/opengraph/${lease.id}`}>{lease.name}</Link></td>
                      <td>
                        {lease.url}
                      </td>
                      <td>
                        {lease.mode}
                      </td>
                      <td>
                        {lease.make?.name}
                      </td>
                    </PublishStatusTableRow>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

      </section>
    );
  }
}

OpenGraphList.defaultProps = {
};

export default withRouter(OpenGraphList);
